import { useBxpWebStargateClient } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client";
import { UserProfile } from "@/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { AsyncResult, useAsync } from "./use-async";

export function useMe(): AsyncResult<UserProfile | null> {
    const stargateClient = useBxpWebStargateClient();

    return useAsync(() => stargateClient.me({}), []);
}
